import React from "react";
import { Badge, Text, Title, Table, Flex } from "@mantine/core";
import { formatNumber } from "utiles/url";

export const TopListTable = ({
  data,
  title,
  headers = [],
  dataKeys = [],  
  selectedBadge,
  setSelectedBadge,
}) => {
  const handleBadgeClick = (badgeValue) => {
    setSelectedBadge(badgeValue);
  };

  const rows = data?.length > 0 ? (
    data.map((item, index) => (
      <tr key={`${title}-${index}`}>
        {dataKeys.map((key, keyIndex) => (
          <td key={`row-${index}-col-${keyIndex}`}>
            <Text
              size="sm"
              weight={keyIndex === 0 ? 600 : 700}  
              color={keyIndex === 0 ? undefined : keyIndex % 2 === 0 ? "green" : "blue"}
              style={{ textTransform: keyIndex === 0 ? "capitalize" : "none" }}
            >
              {typeof item[key] === "number"
                ? formatNumber(item[key])
                : item[key] ?? "-"}
            </Text>
          </td>
        ))}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={headers.length}>
        <Text>No data available</Text>
      </td>
    </tr>
  );

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        marginBottom: "20px",
        width: "380px",
        maxWidth: "400px",
      }}
    >
      <Flex justify="space-between" align="center" mb="md">
        <Title order={4}>{title}</Title>
        <Flex gap="xs">
          {[5, 10, 15].map((badge) => (
            <Badge
              key={badge}
              color={badge === selectedBadge ? "green" : "blue"}
              variant="light"
              onClick={() => handleBadgeClick(badge)}
              style={{ cursor: "pointer" }}
            >
              {badge}
            </Badge>
          ))}
        </Flex>
      </Flex>

      <Table withBorder withColumnBorders striped highlightOnHover mt="sm">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={`header-${index}`}>
                <Text size="sm" weight={600} color="#555">
                  {header}
                </Text>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </div>
  );
};
